var m = require('mithril');
var RequestStatus = require('../enums/RequestStatus')
var requestStatusHandler = {};

// Define custom messages for each status code
var ErrorMessages = {
  400: { title: "Bad Request", description: "The server could not understand your request." },
  401: { title: "Unauthorized", description: "Please log in to access this resource." },
  403: { title: "Forbidden", description: "You do not have permission to access this resource." },
  404: { title: "Not Found", description: "The requested resource was not found." },
  500: { title: "Internal Server Error", description: "Something went wrong on our end." },
  502: { title: "Bad Gateway", description: "The server received an invalid response." },
  503: { title: "Service Unavailable", description: "The service is currently unavailable." },
  504: { title: "Gateway Timeout", description: "The server took too long to respond." }
};

// Default error message
var DefaultErrorMessage = { 
  title: "Error", 
  description: "An unexpected error occurred. Please try again later." 
};


requestStatusHandler.view = function (vnode) {
  if (!vnode.attrs.requestStatus || !vnode.attrs.requestStatus() || vnode.attrs.requestStatus() === RequestStatus.SUCCESS) {
    return;
  }

  if (vnode.attrs.requestStatus() === RequestStatus.ERROR) {
    var statusCode = vnode.attrs.requestStatusCode && vnode.attrs.requestStatusCode() || '';
    var errorData = ErrorMessages[statusCode] || DefaultErrorMessage;

    return m("div.w-100.flex.flex-column.items-center.justify-center.pt5",
      [
        statusCode ? m("h1.mt5", statusCode.toString()) : null,
        m("h2", errorData.title),
        m("div.mt3",  errorData.description),
        typeof vnode.attrs.onRetry === 'function' ? m('button.mt3', {
          type: 'button',
          onclick: function () {
            return vnode.attrs.onRetry();
          }
        }, 'Retry') : null,
      ]
    );
  }

  if (vnode.attrs.requestStatus() === RequestStatus.PENDING) {
    return m('div', [
      m('img.loading', { src: '/images/loading-bars.svg' })
    ]);
  }
};;



module.exports = requestStatusHandler;
